/** @jsx jsx */

import { clients } from "utils/clients";
import { jsx, Variable, StringScalar, render, Mutation, SelectionSet, Field, IdScalar } from "graphql-jsx";
import { UuidScalar, ValidTypeScalar } from "GraphQL/Scalars";
import { ValidType } from "constants/ValidType";

type Option = Readonly<{
  id: string;
  typeArtist: string;
  value: string;
  languageCode?: string;
  validCheck?: ValidType;
}>;

export const UpdateArtistTitleRelation = async (option: Option) => {
  const $id = <Variable name="id" scalar={<UuidScalar />} value={option.id} />;
  const $typeArtist = <Variable name="typeArtist" scalar={<StringScalar />} value={option.typeArtist} />;
  const $value = <Variable name="value" scalar={<StringScalar />} value={option.value} />;
  const $languageCode = <Variable name="language_code" scalar={<IdScalar isNullable />} value={option.languageCode} />;
  const $validCheck = <Variable name="valid_check" scalar={<ValidTypeScalar isNullable />} value={option.validCheck} />;
  const { query, variables } = render(
    <Mutation operationName="UPDATE_ARTIST_TITLE_RELATION">
      <SelectionSet
        name="updateArtist_title"
        alias="updateArtistTitleRelation"
        argument={{
          where: {
            id: $id
          },
          data: {
            type_artist_title: $typeArtist,
            value: $value,
            valid_check: $validCheck,
            language: {
              connect: {
                language_code: $languageCode
              }
            }
          }
        }}
      >
        <Field name="id" />
      </SelectionSet>
    </Mutation>
  );

  type Data = Readonly<{
    updateArtistTitleRelation: {
      id: string;
    };
  }>;

  return await clients.artist.request<Data>(query, variables);
};
